import { Skeleton } from "primereact/skeleton";

import { C } from "sj-ui-toolkit/src/atlas/utils";
import S from "./_styles.module.scss";

const lineLengths = [
  "60%",
  "80%",
  "45%",
  "90%",
  "70%",
  "55%",
  "85%",
  "40%",
  "75%",
  "65%",
  "50%",
  "80%",
];

export default function EditorSkeleton() {
  return (
    <div className={C("flex h-full w-full p-4 gap-4", S.editor)}>
      <div className="flex flex-col gap-3">
        {lineLengths.map((_, index) => (
          <Skeleton key={index} width="1.5rem" height="1.25rem" />
        ))}
      </div>
      <div className="flex flex-col flex-1 gap-3">
        {lineLengths.map((width, index) => (
          <Skeleton key={index} width={width} height="1.25rem" />
        ))}
      </div>
    </div>
  );
}
